module.exports = __webpack_public_path__ + "static/media/add-to-list.02c51c1b.svg";